import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Modal from "../../../Pages/ModalForm";

import "../../BusinessTravel/BTmidBanner/BTmidBanner.css";
import "../../Restrictions/RestrictionLastBanner/RestrictionLastBanner.css";
import "./EntertainmentMidBanner.css";
import Heading from "../../../utls/Heading";

const EntertainmentMidBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = (e) => {
    e.preventDefault(); // Prevent the default anchor behavior
    setShowModal(true); // Show the modal
  };

  const handleClose = () => setShowModal(false); // Close the modal

  return (
    <>
      <div className="enter-last-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-white">
              <Heading className="headings entertainment-head">
                <span className="last-banner-span">Ready</span> for Your Next
                Creative Journey{" "}
                <span className="text-white" style={{ fontWeight: "bold" }}>
                  {" "}
                  ?{" "}
                </span>
              </Heading>
              <p className="enter-p">
                Contact us now for a flawless travel experience!
              </p>
              <div className="carouselCaption">
                <button
                  className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold"
                  type="button"
                  onClick={handleShow}
                >
                  GET IN TOUCH
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="enter-last-img">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/entermidbanner.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conditionally render the Modal */}
      <Modal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default EntertainmentMidBanner;
